import React, { StrictMode } from 'react';
import ReactHighcharts from 'react-highcharts';
import { Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import GaugeComponent from 'react-gauge-component';

const utils = require('../../components/utils');
const BORDER_COLOR = '#666666';

const RevenuePerformanceDeviation = ({panelRevenuePerformance, pubRevPerformance, loading}) => {
    let averagePersiodPublisherEfficiency = 0;
    let value = 0;

    if(pubRevPerformance?.length > 0) {
      averagePersiodPublisherEfficiency = (pubRevPerformance.reduce((p, c) => p + c.y, 0))/pubRevPerformance.length;

      const { median_br_rpm_01, median_br_rpm_25, median_br_rpm, median_br_rpm_75, median_br_rpm_99, min_br_rpm, max_br_rpm } = panelRevenuePerformance || {};
    
      if (averagePersiodPublisherEfficiency > Number(median_br_rpm)) {
        value = ((averagePersiodPublisherEfficiency-Number(median_br_rpm))*100)/(Number(max_br_rpm)-Number(median_br_rpm))
      }
      
      if (averagePersiodPublisherEfficiency < Number(median_br_rpm)) {
        value = ((averagePersiodPublisherEfficiency-Number(median_br_rpm))*100)/(Number(median_br_rpm)-Number(min_br_rpm))
      }
    }

    const config = {
      chart: {
        backgroundColor: 'none',
        borderColor: BORDER_COLOR,
        borderWidth: 1,
      },
      title: {
          text: 'RPM-BR SCORE',
          style: { color: '#ffffff', fontSize: '12px', fontWeight: 600 }
      },
      credits: {
        enabled: false
      }
    }

    return (
      <div style={{position: 'relative'}}>
        <Tooltip title={
          <React.Fragment>
            Average revenue per million bid requests deviation from panel median
          </React.Fragment>
        } style={{position: 'absolute', right: 0, margin: '10px', zIndex: 1}}>
          <HelpIcon/>
        </Tooltip>
        <div style={{position: 'absolute', width: '100%'}}>
          <ReactHighcharts config={config} />
        </div>
        {  !loading && <GaugeComponent
            style={{position: 'absolute' , width: '70%', height: '100%', left: 0, right: 0, verticalAlign: 'center', textAlign: 'center', margin: 'auto', top: '80px'}}
            type={"semicircle"}
            arc={{
                width: 0.2,
                padding: 0.005,
                cornerRadius: 1,
                subArcs: [
                  {
                    limit: 10,
                    color: 'red',
                    tooltip: {
                      text: 'Too low temperature!'
                    },
                  },
                  {
                    limit: 25,
                    color: 'orange',
                    tooltip: {
                      text: 'Low temperature!'
                    }
                  },
                  {
                    limit: 50,
                    color: 'yellow',
                    tooltip: {
                      text: 'OK temperature!'
                    }
                  },
                  {
                    limit: 75, color: '#80C342',
                    tooltip: {
                      text: 'High temperature!'
                    }
                  },
                  {
                    limit: 90,
                    color: '#47B649',
                    tooltip: {
                      text: 'Too high temperature!'
                    }
                  },
                  {
                    color: '#118B44',
                    tooltip: {
                      text: 'Too high temperature!'
                    }
                  }
                ]
              }}
            pointer={{ color: 'grey', length: 0.80, width: 15 }}
            labels={{
              valueLabel: { formatTextValue: () => utils.roundDouble(value, 1) + '%' },
              tickLabels: {
                type: 'inner',
                defaultTickValueConfig: {formatTextValue: function (v) { return '' }},
              }
            }}
            value={50 + value }
          />
        }
      </div>
    )
}

export default RevenuePerformanceDeviation;